export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const setActiveTab = (sectionId) => ({
    type: SET_ACTIVE_TAB,
    payload: { activeSectionId: sectionId },
});
